import React, { Component } from 'react';

import './AnimatedImage.scss';

import {
	TimelineMax,
	TweenMax
} from 'gsap';
import $ from 'jquery';

import {
    Dispatcher,
    Actions,
    Events
} from '../flux';

class AnimatedImage extends Component {

	constructor() {
        super();
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $; 

        this.state = {
            imageClass: ''
        }

        this.imageReveal = this.imageReveal.bind(this);
        this.inView = this.inView.bind(this);
	}
    
    inView(el, offset = 0) {
        if (el != undefined) {
            const top = el.getBoundingClientRect().top;
            return (top + offset) >= 0 && (top - offset) <= (window.innerHeight - 100);
        } else {
            return false;
        }
    }

    imageReveal() {
        if ( this.inView(this.refs.image) && this.state.imageClass == '' ) {
            this.setState({ imageClass: 'reveal'});
        }
    }

    componentDidMount() {
        window.addEventListener('wheel', this.imageReveal);
    }

    componentWillUnount() {
        window.removeEventListener('wheel', this.imageReveal);
    }

	render() {
		var classItem = [
			'animated_image',
            this.state.imageClass
		];

        return (
        	<div className={ classItem.join(' ') } ref="image">
                <img src={ this.props.src } className="bg_image" />

                <div className="layer1"></div>
                <div className="layer2"></div>
            </div>
    	);
	}
}

export { AnimatedImage };